import React from 'react';
import { RefreshCw, HelpCircle } from 'lucide-react';
import { useModal } from '../hooks/useFeedbackModal';
import { formatTokenBalance } from '../utils/format';

const StatCard = ({ title, value, infoContent }) => {
  const modal = useModal();

  const showInfo = () => {
    modal.showModal({
      title: title,
      description: infoContent,
      type: 'info'
    });
  };

  return (
    <div className="p-4 bg-gray-50 dark:bg-gray-700 rounded-xl relative ">
      <button 
        onClick={showInfo}
        className="absolute top-2 right-2 "
      >
        <HelpCircle className="w-4 h-4 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200" />
      </button>
      <p className="text-sm text-gray-500 dark:text-gray-400">{title}</p>
      <p className="text-2xl font-bold">{value}</p>
    </div>
  );
};

const LoadingSkeleton = () => (
  <div className="space-y-4 animate-pulse">
    <div className="h-8 w-48 bg-gray-200 dark:bg-gray-700 rounded" />
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {[...Array(3)].map((_, i) => (
        <div key={i} className="h-24 bg-gray-200 dark:bg-gray-700 rounded-xl" />
      ))}
    </div>
  </div>
);

const PoolInfo = ({ poolState, refresh, loading }) => {
  const rate = poolState ? BigInt((poolState.reward_rate || 0) * 3600) : 0n;

  if (loading) {
    return (
      <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-purple-500 to-pink-500 p-[1px]">
        <div className="relative bg-white dark:bg-gray-800 p-6 rounded-2xl h-full">
          <LoadingSkeleton />
        </div>
      </div>
    );
  }

  return (
    <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-purple-500 to-pink-500 p-[1px]">
      <div className="relative bg-white dark:bg-gray-800 p-6 rounded-2xl h-full">
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <h2 className="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-purple-600 to-pink-600">
              Pool Stats
            </h2>
            <button 
              onClick={refresh} 
              className="p-2 hover:scale-110 transition-transform"
            >
              <RefreshCw className="w-5 h-5 text-gray-600 dark:text-gray-400" />
            </button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <StatCard
              title="Total Staked"
              value={formatTokenBalance(BigInt(poolState.total_staked), 6, 1)}
              infoContent="The total amount of MONOPOLY tokens currently staked in the pool by all participants."
            />
            <StatCard
              title="Reward Rate"
              value={`${formatTokenBalance(rate, 9, 2)} ROLL/hour`}
              infoContent="The rate at which ROLL tokens are distributed to stakers. This rate is shared proportionally among all stakers based on their stake amount."
            />
            <StatCard
              title="Fee"
              value={`${poolState.fee_percentage}%`}
              infoContent="A small percentage fee taken from $MONOPOLY deposits. This fee helps sustain the rewards pool and the $MONOPOLY ecosystem"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PoolInfo;
